var app = angular.module("leonardo");

var VendorCategoryListFilters = function(
  $scope,
  $controller
) {

  $controller('FiltersBaseController', { $scope: $scope });

  $scope.filters_options = [
    {
      id: 'vendor_category_name',
      name: 'Vendor Category Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Vendor category name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];
};

app.controller('VendorCategoryListFilters', [
  '$scope',
  '$controller',
  VendorCategoryListFilters
]);
